import PropTypes from 'prop-types';
import React from 'react';

import { insertNewLine } from '@/utils';
import {
  Content,
  Title,
  VerticalDescription,
  HorizontalDescription,
  PlaneDescription,
  DescriptionWrapper,
} from '@/components/Article/TextSection.style';
import Section from '../Section';

const TextSection = ({ entryId, title, description, orientation }) => (
  <Section id={entryId} options={{ content: { locked: true } }}>
    <Content>
      <DescriptionWrapper orientation={orientation}>
        <Title
          orientation={orientation === 'Horizontal' ? '50%' : '100%'}
          marginRight={orientation === 'Horizontal' && '50px'}
        >
          {title}
        </Title>
        {insertNewLine({
          key: 'text-section',
          description,
          component:
            orientation === 'Vertical'
              ? VerticalDescription
              : orientation === 'Horizontal'
                ? HorizontalDescription
                : PlaneDescription,
        })}
      </DescriptionWrapper>
    </Content>
  </Section>
);

TextSection.defaultProps = {
  entryId: undefined,
  orientation: undefined,
};

TextSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  entryId: PropTypes.string,
  // undefined の場合は、Plane とみなす。
  orientation: PropTypes.string,
};

export default TextSection;



// WEBPACK FOOTER //
// ./src/components/Article/TextSection.js